/**
 * Ghost cursor replayed on the slide during voice-note playback.
 *
 * A single absolutely-positioned DOM node; `useVoiceNotePlayback`'s rAF loop
 * sets its transform / opacity directly (no React re-render per frame), the
 * same way `PresenceCursors` moves peer cursors.
 */
import type { RefObject } from "react"

const CURSOR_PATH = "M0 0L10 9L0 14Z"
const GHOST_COLOR = "#f59e0b"

interface VoiceNoteGhostCursorProps {
  ghostRef: RefObject<HTMLDivElement | null>
  label: string | null
}

export function VoiceNoteGhostCursor({ ghostRef, label }: VoiceNoteGhostCursorProps) {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      <div ref={ghostRef} className="absolute left-0 top-0 transition-opacity duration-150" style={{ opacity: 0 }}>
        <svg width="18" height="18" viewBox="-1 -1 18 18" fill="none" className="-ml-px -mt-px block">
          <path d={CURSOR_PATH} fill={GHOST_COLOR} stroke="white" strokeWidth="1" />
        </svg>
        <div
          className="absolute left-3.5 top-3 whitespace-nowrap rounded-sm px-1.5 py-px text-[10px] font-medium leading-[14px] text-black"
          style={{ background: GHOST_COLOR }}
        >
          ▶ {label?.trim() || "Voice note"}
        </div>
      </div>
    </div>
  )
}
